module.exports = __webpack_public_path__ + "static/media/za-nju-i-njega.f2c8fbbc.png";